import gql from 'graphql-tag';

export default gql`
mutation sendNewCustomDomainEmail($subject: String!, $to: String!, $html: String!) {
  sendEmail(object: {to: $to, subject: $subject, html: $html}) {
    info
  }
}
`;
